import { render, staticRenderFns } from "./ServicePorts.vue?vue&type=template&id=ff860422&scoped=true&"
import script from "./ServicePorts.vue?vue&type=script&lang=js&"
export * from "./ServicePorts.vue?vue&type=script&lang=js&"
import style0 from "./ServicePorts.vue?vue&type=style&index=0&id=ff860422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff860422",
  null
  
)

export default component.exports